import { Statuses, Task, TaskLevel } from 'app/entities/Task';
import {AfterViewInit, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';
import * as moment from 'moment';
import { environment, productModels } from '../../../../environments/environment';
import { TaskService } from '../../../services/task.service';
import { GantChart } from '../../../entities/GantChart';
import { Job } from '../../../entities/Job';
import { Router } from '@angular/router';
import { TaskPageModel } from '../../../entities/PageModel';
import { ConverterService } from '../../../services/converter.service';
import { NotificationService } from '../../../services/notification.service';
import { DateRangeFilter, FilterModel } from '../../../entities/FilterModel';
import { AppConfig } from '../../../app.config';
import { Resource } from '../../../entities/Resource';
import { AppTaskCategory } from '../../../entities/AppTaskCategory';
import { TaskActivityService } from '../../../services/task-activity.service';
import { ExternalFilterField } from '../../../entities/ExternalFilterField';
import { ExternalFilter } from 'app/entities/ExternalFilter';
import { DatePickerModel } from '../../../entities/DatePickerModel';
import { SessionService } from 'app/services/session.service';
import { TranslationPipe } from 'app/pipes/TranslationPipe';


declare var $: any;


@Component({
  selector: 'app-gant-chart-view',
  templateUrl: './gant-chart-view.component.html',
  styleUrls: ['./gant-chart-view.component.css']
})
export class GantChartViewComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly mobileBreakpoint = 767;
  
  validateStyle: boolean;

  public languages = new Map<string, string>();

  @Input()
  set ValidateStyles(validate: boolean) {
    this.validateStyle = validate;
  }

  @Input()
  calendarDate: string;

  @Input()
  AppTaskCategories: AppTaskCategory[];

  @Input()
  chosenCategory: AppTaskCategory;

  @Input()
  responsibles: Resource[];

  @Input()
  chosenResponsible: Resource;

  @Input()
  chosenStatus: string;

  @Input()
  ChosenJob: Job;

  @Input()
  maxResourceNameLength: number;

  @Input()
  maxResourceCodeLength: number;

  @Input()
  jobsTaskToggled: boolean;

  @Input()
  set gantChart(gant: GantChart) {
    this._gantChart = gant;
  }

  isResizingOrNewContent = true;
  @Input()
  set IsResizingOrNewContent(value: boolean) {
    this.isResizingOrNewContent = value;
  }

  @Input()
  set ChosenDatePeriod(value: string) {

    this.chosenDatePeriod = value
    this.validateStyles(this.screenHeightInPx);
  }

  @Input()
  set DateChanged(value: boolean) {
    this.dateChanged = value;
  }

  _showDatesOnResource: boolean;
  @Input()
  set showDatesOnResource(value: boolean) {
    if (value != null) {
      this._showDatesOnResource = value;
    }
  }

  @Input('ExternalFilter')
  set ExternalFilter(value: ExternalFilter) {
    this.externalFilter = value;
  }

  @Input('YearSlotWidth')
  set YearSlotWidth(value: number) {
    this.yearSlotWidth = value;
  }

  @Input("CurrentLanguage")
  set CurrentLanguage(currentLanguage: string) {
    this.currentLanguage = currentLanguage;
  }
  
  @Input()
  set ListToShow(listToShow: string) {
    this.listToShow = listToShow;
  }

  @Input()
  set Duration(duration: number) {
    this.duration = duration;
  }
  
  @Input()
  set DatePicker(datePicker: DatePickerModel) {
    this.DatePickerModel = datePicker;
  }

  @Input()
  set CurrentView(currentView: string) {
    this.currentView = currentView;
  }
  
  @Input()
  set ScreenHeight(screenHeightInPx: number) {
    this.screenHeightInPx = screenHeightInPx;
  }
    
  @Input()
  loggedInUserNo: string;

  @Output()
  isInitializedEmitter = new EventEmitter();

  @Output()
  updateTaskEmitter = new EventEmitter();

  @Output()
  updateActivitiesEmitter = new EventEmitter();

  @Output()
  applyTaskTimeEmitter = new EventEmitter();

  @Output()
  updateTaskTimeEmitter = new EventEmitter();

  @Output()
  toggleResourceSortEmitter = new EventEmitter();

  @Output()
  refreshCurrentTaskListEmitter = new EventEmitter();

  @Output()
  resourceAreaResizedEmitter = new EventEmitter();

  @Output()
  toggleShowDatesOnResourceEmitter = new EventEmitter();

  @Output()
  refreshCalendarEmitter = new EventEmitter();

  @Output()
  changeChosenResponsibleEmitter = new EventEmitter();

  @Output()
  changeChosenCategoryEmitter = new EventEmitter();

  @Output()
  changeChosenStatusEmitter = new EventEmitter();

  @Output()
  validateFilterFieldEmitter = new EventEmitter();

  @Output()
  dateChangedEmitter = new EventEmitter();

  @Output()
  loadingEmitter = new EventEmitter();

  @Output()
  currentViewEmitter = new EventEmitter();

  @Output()
  updateGantChartEmitter = new EventEmitter();

  @Output()
  openModalEmitter = new EventEmitter();

  isInitialized: boolean;
  public firstRun: Boolean = true;
  public calendarRerendered: Boolean = false;
  public _gantChart: GantChart;
  public dateChanged: boolean;
  public taskStatuses = Statuses;
  public externalFilter: ExternalFilter;
  public chosenTask: Task;
  public keys: string[];
  public duration = 7;
  public isDragging: boolean;
  public yearSlotWidth: number = 3;
  public monthSlotWidth: number = 30;
  public dynamicSlotWidth: number = 10;
  public stateChange: boolean = false;
  public DatePickerModel: DatePickerModel;
  public currentView = 'yearTimeline';
  public doWork: boolean;
  public showCalendar: boolean;
  screenHeightInPx: number;
  private screenHeight: number;
  private screenWidth: number;
  public scrollerClipContent: any;
  public scrollerClipLeft: any;
  public scroller: any;
  public scrollerHeight: any;
  public scrollerWidth: any;
  public productModels = productModels;
  public currentProductModel: any;
  chosenDatePeriod: string;
  currentLanguage: string;
  listToShow: string;
  public jqueryCalendar = null;
  


  constructor(private taskservice: TaskService,
    private router: Router,
    private convertservice: ConverterService,
    private notificationService: NotificationService,
    private appConfig: AppConfig,
    private activityService: TaskActivityService,
    private translationPipe: TranslationPipe,
    private sessionService: SessionService,
    ) {
  }

  get IsSelectedCompanyOTS() {
    return this.sessionService.getCompanyType() === TaskLevel.OTS;
  }

  private isMobileView(): boolean {
    return window.innerWidth <= this.mobileBreakpoint;
  }

  private getTimelineSlotWidth(defaultWidth: number, mobileMinWidth: number, mobileRatio: number): number {
    if (!this.isMobileView()) {
      return defaultWidth;
    }

    return Math.max(mobileMinWidth, window.innerWidth * mobileRatio);
  }

  ngOnInit() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    this.showCalendar = true;
    this.chosenTask = new Task();
    this.isDragging = false;
    this.jqueryCalendar = $('#calendar');
    
    this.currentProductModel = this.appConfig.getConfig('productModel');

    if (this.currentProductModel == productModels.Premium) {
      this.jobsTaskToggled = true;
    } else if (this.currentProductModel == productModels.Premium) {
      this.jobsTaskToggled = false;
    }

    if (this.currentProductModel == productModels.Premium) {
      this.rerenderCalendar(this._gantChart, true);
    }

    this.keys = Object.keys(this.taskStatuses).filter(k => !isNaN(Number(k)));
  }

  ngAfterViewInit() {
    this.scrollerClipContent = $('.fc-body .fc-time-area .fc-scroller-clip');
    this.scrollerClipLeft = $('.fc-body .fc-resource-area .fc-scroller-clip');
    this.scroller = $('.fc-body .fc-resource-area .fc-scroller');
    $('.calenderDiv').css('margin-bottom', '0px');
    const viewportHeight = $(window).height();
    this.validateStyles(viewportHeight - 380)

    if (this.isMobileView()) {
      $('body').css('overflow', 'auto');
      return;
    }

    $('body').css('overflow', 'hidden')
  }

  ngOnDestroy(): void {
    // This is needed to remove the tooltip when getting logged out due to 401 auth error.
    $('.tooltipevent').remove()
  }

  validateStyles(highestHeight: number) {
    if (this.isMobileView()) {
      $('.fc-body .fc-time-area .fc-scroller').css({
        'max-height': 'none',
        'overflow-x': 'auto',
        'overflow-y': 'visible'
      });
      $('.fc-body .fc-resource-area .fc-scroller').css({
        'max-height': 'none',
        'overflow-y': 'visible'
      });
      $('.fc-body .fc-time-area .fc-scroller-clip').css('height', 'auto');
      $('.fc-body .fc-resource-area .fc-scroller-clip').css('height', 'auto');
      $('#second-panel-default').css('min-height', '0');
      $('#second-panel-default').css('height', 'auto');
      $('tbody .fc-divider').css('height', 'auto');
      $('tbody .fc-slats').css('height', 'auto');
      $('tbody .fc-scroller-canvas').css('height', 'auto');
      $('tbody .fc-nonbusiness').css('height', 'auto');
      $('tbody .fc-view').css('height', 'auto');
      $('tbody .fc-time-area').css('height', 'auto');
      $('tbody .fc-resource-area').css('height', 'auto');
      return;
    }

    highestHeight = highestHeight - 37
    const dateRangeFilters = Object.keys(DateRangeFilter).filter(o => isNaN(Number(o)))
    if (this.chosenDatePeriod === dateRangeFilters[DateRangeFilter.Week].toString() || this.chosenDatePeriod === dateRangeFilters[DateRangeFilter.FourteenDays] || this.chosenDatePeriod === dateRangeFilters[DateRangeFilter.Month]) {
      $('.fc-body .fc-time-area .fc-scroller').css('overflow-x', 'hidden')
    }
    $('.fc-body .fc-time-area .fc-scroller').css('max-height', highestHeight)
    $('.fc-body .fc-resource-area .fc-scroller').css('max-height', highestHeight)
    $('.calenderDiv').css('margin-bottom', '0px');
    $('.fc-body .fc-time-area .fc-scroller-clip').height(highestHeight)
    $('.fc-body .fc-resource-area .fc-scroller-clip').height(highestHeight)
    $('#second-panel-default').css('min-height', highestHeight - 115)
    $('#second-panel-default').css('height', highestHeight)
    $('tbody .fc-divider').css('height', highestHeight)
    $('tbody .fc-slats').css('height', highestHeight)
    $('tbody .fc-scroller-canvas').css('height', highestHeight)
    $('tbody .fc-nonbusiness').css('height', highestHeight)
    $('tbody .fc-view').css('height', highestHeight)
    $('tbody .fc-time-area').css('height', highestHeight)
    $('tbody .fc-resource-area').css('height', highestHeight)
    const widgetWidth = $('.fc-time-area .fc-scroller-canvas .fc-content .fc-rows tbody').width();
    const backgroundColorHeight = $('.fc-scroller-canvas .fc-content .fc-rows table').height()
    if ($('.fc-body .fc-time-area .fc-scroller') < widgetWidth) {
      $('.fc-body .fc-time-area .fc-scroller').css('overflow-x', 'hidden')
    }
    if (backgroundColorHeight > highestHeight) {
      $('.fc-bgevent-container .fc-nonbusiness').height(backgroundColorHeight)
      $('.fc-slats tbody').height(backgroundColorHeight)
    }
  }

  updateTask(task: Task) {
    this.updateTaskEmitter.emit(task);
  }

  /***
   * This method is called when a Task is updated from getting dropped inside the calendar.
   * @param task
   */
  updateTaskTime(task: Task) {
    this.loadingEmitter.emit(true);
    this.updateTaskTimeEmitter.emit(task)
  }

  /***
   * This method is called when a Task is dropped from a external list.
   * @param task
   */
  applyTaskTime(task: Task) {
    this.loadingEmitter.emit(true);
    this.dateChangedEmitter.emit(true);
    this.applyTaskTimeEmitter.emit(task);
  }

  redirectToScheduler(taskNo: string) {
    this.router.navigateByUrl('/scheduler/' + 'Opgave/' + taskNo);
  }

  setScrollerDimensions() {
    this.scroller = $('.fc-body .fc-resource-area .fc-scroller')[0];
    this.scrollerHeight = 0;
    this.scrollerWidth = 0;

    if (this.scroller) {
      this.scrollerHeight = this.scroller.scrollTop;
      this.scrollerWidth = this.scroller.scrollLeft;
    }
  }

  applyeScrollerDimensions() {
    let scroller = $('.fc-body .fc-time-area .fc-scroller')[0];
    if (scroller) {
      scroller.scrollTop = this.scrollerHeight;
      scroller.scrollLeft = this.scrollerWidth;
      let self = this;
      setTimeout(function () {
        scroller.scrollTop = self.scrollerHeight;
        scroller.scrollLeft = self.scrollerWidth;
      }, 0);
    }
  }

  

  rerenderCalendar(gantChart: GantChart, force = false) {
    let d1 = moment(new Date());
    this.setScrollerDimensions();
    
    this._gantChart = gantChart;
    let self = this;
    let jqueryCalendar = $('#calendar');
    

    // Wait for view to load about 200ms
    setTimeout(function () {
      if (!force) {
        if (!self.firstRun && jqueryCalendar.fullCalendar('getView').type != undefined) {
          self.currentView = jqueryCalendar.fullCalendar('getView').type;
        }

        self.firstRun = false;
        self.dateChangedEmitter.emit(false);

        self.doWork = false;
        if (gantChart != null) {
          self.doWork = true;
          if (self.doWork == true) {
            $('#calendar').fullCalendar('removeEvents');
            $('#calendar').fullCalendar('refetchResources');
          }
          if (self.doWork == true) {

            $('#calendar').fullCalendar('addEventSource', gantChart.PlacedTasks);
            self.doWork = false;
            self.loadingEmitter.emit(false);
          } else {
            self.rerenderCalendar(gantChart);
          }
        }

      } else {
        jqueryCalendar.fullCalendar('destroy');
        jqueryCalendar.fullCalendar('render');
        self.dateChangedEmitter.emit(false);
        self.loadingEmitter.emit(false);
        self.firstRun = false;

      }
    }, 200);
    if (this.isInitialized && this.validateStyle) {
      this.validateStyles(this.screenHeightInPx - 380)
    }
  }

  setCurrentLanguage(language) {
    this.dateChangedEmitter.emit(true);
    this.rerenderCalendar(this._gantChart);
  }

  openModal(task: Task) {
    this.chosenTask = Object.assign({}, task);
    $('#myModal').modal('show');
  }

  openWarningModal() {
    $('#warningModal').modal('show');
  }

  dropEvent(event, bool) {
    if (!bool) {
      event.eventStartEditable = false;
      this.updateTaskTime({ Task_GUID: event.TaskRef, start: event.start, end: event.end, Company_Reference: event.Company_Reference });
      event.OrigResourceRef = event.resourceId;
    } else {
      this.openWarningModal();
    }
    this.setDragging(false);
  }

  getTaskTooltip(event: any) {
    let style = 'font-family: Helvetica; overflow: hidden;display:block; height: auto; border: 1px solid #cccccc; background-color: whitesmoke; border-radius: 3px; padding-top: 5px; padding-bottom: 5px;';
    let dateString = this.convertservice.DatesToString(event.start, event.end);
    let dateTag = dateString != '' ? '<p style="' + style + '+">' + dateString + '</p>' : '';

    var tooltip = '<div class="tooltipevent panel panel-default" align="center" ' +
      'style="width:260px;height:auto;position:absolute;' +
      'z-index:10001;border-radius: 6px;box-shadow: 1px 1px 5px"' +
      '><div class="panel-heading"><strong>' + event.Title + '</strong></div><div class="panel-body">' +
      dateTag +
      '<p style="' + style + '+"><strong>' + this.translationPipe.transform('TagNumber') + ':</strong> ' + event.Maintenance_Object + ' </p>' +
      '<p style="' + style + '+"><strong>' + this.translationPipe.transform('Description') + ':</strong> ' + event.Job_Description + ' </p>' +
      '<p style="' + style + '+"><strong>' + this.translationPipe.transform('Category') + ':</strong> ' + event.App_Task_Category_Description + ' </p>' +
      '</div></div>';

    return tooltip;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }

  getDateFromCalendar(date: any) {
    return new Date(moment(date).format(environment.START_DATETIME_FORMAT))
  }

  eventExistsOnElement(element, evntType, eventName) {
    let check = false;
    if (!!element && !!element.get(0)) {
      let elemEvents = $._data(element.get(0), 'events');

      if (!!elemEvents) {
        let evts = elemEvents[evntType];
        if (!!evts) {
          for (let i = 0; i < evts.length; i++) {
            if (evts[i].data == eventName) {
              check = true;
              break;
            }
          }
        }
      }
    }

    return check;
  }

  setScrollerHandler() {
    let self = this;
    self.setScrollerDimensions();
  };

  applyScrollerHandler() {
    let self = this;
    // If there is some html elements with .fc-resource-area class
    if ($('.fc-resource-area').length > 0) {
      let width = $('.fc-resource-area')[0].offsetWidth;
      self.applyeScrollerDimensions();
      self.resourceAreaResizedEmitter.emit(width);
    }
  };


  addTriggers() {
    let self = this;
    if (!self.eventExistsOnElement($('.fc table'), 'click', 'setScrollerHandler')) {
      $('.fc table').click('setScrollerHandler', $.proxy(this.setScrollerHandler, this));
    }
    if (!self.eventExistsOnElement($('.fc-header-toolbar'), 'mousedown', 'setScrollerHandler')) {
      $('.fc-header-toolbar').mousedown('setScrollerHandler', $.proxy(this.setScrollerHandler, this));
    }
    if (!self.eventExistsOnElement($('.fc-divider'), 'mousedown', 'setScrollerHandler')) {
      $('.fc-divider').mousedown('setScrollerHandler', $.proxy(this.setScrollerHandler, this));
    }
    if (!self.eventExistsOnElement($('.fc-divider'), 'mouseup', 'applyScrollerHandler')) {
      $('.fc-divider').mouseup('applyScrollerHandler', $.proxy(this.applyScrollerHandler, this));
    }
  }


  public InitJS() {
    let self = this;
    const dateRangeTimeLineView: any = {
      slotWidth: self.getTimelineSlotWidth(self.dynamicSlotWidth, 3.2, 0.011),
      duration: { days: self.duration },
      type: 'timelineMonth',
      buttonText: 'Datointerval',
      slotLabelInterval: { days: 1 },
      allDay: true,
    };

    if (self.isMobileView()) {
      dateRangeTimeLineView.slotLabelFormat = ['[Uge] W', 'D'];
    }

    $('#calendar').fullCalendar({
      height: 'fit-parent',
      schedulerLicenseKey: environment.SCHEDULER_TOKEN,
      locale: this.convertservice.URLLanguageParamToFullCalendarFormat(this.currentLanguage),
      timeZone: 'utc',
      defaultView: self.currentView,
      editable: true,
      droppable: true, // this allows things to be dropped onto the calendar !!!
      dragRevertDuration: 0,
      lazyFetching: true,
      minTime: '07:00:00',
      weekNumbers: true,
      maxTime: '18:00:00',
      resourceAreaWidth: self.isMobileView() ? '0px' : (self.maxResourceNameLength + 25) + 'px',
      defaultDate: self.DatePickerModel.StartDate,
      displayEventTime: false,

      views: {
        allDayWeekTimeline: {
          slotWidth: self.getTimelineSlotWidth(self.monthSlotWidth, 6, 0.02),
          type: 'timelineMonth'
        },
        yearTimeline: {
          slotWidth: self.getTimelineSlotWidth(self.yearSlotWidth, 0.9, 0.0025),
          buttonText: 'År',
          slotLabelFormat: [
            'MMMM', // top level of text
            '|'
          ],
          type: 'timelineYear'
        },
        dateRangeTimeLine: dateRangeTimeLineView
      },

      customButtons: {
        firstEventMonthBtn: {
          text: 'Start',
          click: function () {
            if (self._gantChart.PlacedTasks[0] != null) {
              let placedArray = self._gantChart.PlacedTasks.filter(function (element, index, array) {

                return element.constraint != null

              });
              if (placedArray != null) {
                let sortedArray = placedArray.sort(function (a, b) {
                  return new Date(a.start).getTime() - new Date(b.start).getTime()
                });
                $('#calendar').fullCalendar('gotoDate', sortedArray[0].start);
              }
            }
          }
        },
      },


      resourceLabelText: self.isMobileView() ? '' : (self.chosenResponsible != null ? self.chosenResponsible.Name : this.translationPipe.transform('AllResources')),
      header: {

        left: self.currentProductModel === productModels.Premium ? 'prev,next today, firstEventMonthBtn, downloadPdfBtn' : '',
        center: self.currentProductModel === productModels.Premium ? 'title' : '',
        right: self.currentProductModel === productModels.Premium ? 'timelineWeek,allDayWeekTimeline,yearTimeline,dateRangeTimeLine' : ''
      },

      businessHours: {
        // days of week. an array of zero-based day of week integers (0=Sunday)
        dow: [1, 2, 3, 4, 5], // Monday - Thursday

        start: '07:00', // a start time (10am in this example)
        end: '17:00', // an end time (6pm in this example)
      },
      resources: this._gantChart.JobTasks,
      events: this._gantChart.PlacedTasks,
      // <!-- Maintenance -->
      navLinks: self.currentProductModel === productModels.Premium,
      // other options go here...


      // This function is called when an external event is dropped
      drop: function (date, jsEvent, ui, resourceId) {

        // retrieve the dropped element's stored Event Object
        var originalEventObject = $(this).data('eventObject');
        originalEventObject.resourceId = resourceId;


        // we need to copy it, so that multiple events don't have a reference to the same object
        let copiedEventObject = $.extend({}, originalEventObject);

        // assign it the date that was reported
        copiedEventObject.start = date;

        // set the date to Danish timezone
        let startDate = date.format(environment.START_DATETIME_FORMAT);

        copiedEventObject.start = startDate;
        if (self.currentView == 'yearTimeline') {
          let endDate = new Date(copiedEventObject.start);
          let s = moment(endDate.setMonth(endDate.getMonth() + 1));
          copiedEventObject.end = s.format(environment.START_DATETIME_FORMAT);
        } else {
          copiedEventObject.end = copiedEventObject.start;
        }


        //copiedEventObject.end = copiedEventObject.start;
        self.applyTaskTime({
          Task_GUID: copiedEventObject.TaskRef,
          start: copiedEventObject.start,
          end: copiedEventObject.end
        });
      },


      // This function is called when a event is dropped inside the calendar
      eventDrop: function (event, delta, revertFunc) {

        if (!!event.CalcEstimate) {
          if (confirm('Der er planlagt ' + event.CalcEstimate + ' timer på ressourcer for denne sagsopgave \nEr du sikker på du stadig vil flytte den til: ' +
            moment(new Date(event.start)).format(environment.START_DATETIME_FORMAT_DANISH) + ' - ' + moment(new Date(event.end).setDate(new Date(event.end).getDate() - 1)).format(environment.START_DATETIME_FORMAT_DANISH)
            + '\nBemærk alt planlægning herunder skal gøres manuelt. ')) {
            self.updateEventFromEventDrop(event);
          } else {
            revertFunc();
          }
        } else {
          self.updateEventFromEventDrop(event);
        }
      },


      // This funtion is called when a event is resized
      eventResize: function (event, delta, revertFunc) {
        self.updateTaskTime({ Task_GUID: event.TaskRef, start: event.start, end: event.end, Company_Reference: event.Company_Reference });
      },

      eventDragStart: function (event, jsEvent, ui, view) {
        self.setDragging(true);
      },

      // This function is called when a event is dropped on the external event list.
      eventDragStop: function (event, jsEvent, ui, view) {
        if (jsEvent != null && event != null) {
          if (isEventOverDiv(jsEvent.clientX, jsEvent.clientY)) {

            var tooltip = '<div class="tooltipDeleteEvent panel panel-default" align="center" ' +
              'style="width:260px;height:280px;position:absolute;' +
              'z-index:10001;border-radius: 6px;box-shadow: 1px 1px 5px"' +
              '><div class="panel-heading"><strong>' + 'Fjern tid?' + '</strong>' +
              '<button type="button" id="cancelActionBtn" class="close cancelAction" data-dismiss="modal">&times;</button></div>' +
              '<div class="panel-body">' +
              '<p>' + 'Er du sikker på at du vil slette tid for ' + '</p><pre>' + event.resourceId + ' </pre>' + '<p>På opgave </p><pre>' + event.title + '</pre>' +
              '<button id="DeleteEventBtn" class="btn btn-danger">Slet</button>' +
              '<button id="CancelDeleteBtn" class="btn btn-default cancelAction" style="margin-left: 20px;">Fortryd</button>' +
              '</div>' +
              '</div>';
            $('body').append(tooltip);
            $(this).css('z-index', 10000);
            $('.tooltipDeleteEvent').fadeIn('500');
            $('.tooltipDeleteEvent').fadeTo('10', 1.9);
            $('.tooltipDeleteEvent').css('top', jsEvent.pageY + -145);
            $('.tooltipDeleteEvent').css('left', jsEvent.pageX + -120);

            $('#DeleteEventBtn').click(function () {

              $('#calendar').fullCalendar('removeEvents', event._id);
              self.applyTaskTime({
                Task_GUID: event.TaskRef,
                start: environment.DEFAULT_DATETIME_FULL,
                end: environment.DEFAULT_DATETIME_FULL
              });
              //self.removeEmployeeTimePlan(event.TimePlanRef, event.TaskRef, event.resourceId);
              $('.tooltipDeleteEvent').remove();
            });
            $('#CancelDeleteBtn').click(function () {
              $('.tooltipDeleteEvent').remove();
            });

            $('.cancelAction').click(function () {
              $('.tooltipDeleteEvent').remove();
            });
          }
        } else {
          //self.rerenderCalendar(self.calendar);
        };
        self.setDragging(false);
      },

      eventAllow: function (dropInfo, draggedEvent) {
        return !(TaskLevel[draggedEvent.TaskLevel] === TaskLevel.OTS && !self.IsSelectedCompanyOTS);
      },

      eventRender: function (event, element) {
        const eventTrigger = self.isMobileView() && self.currentProductModel == productModels.Maintenance ? 'click' : 'dblclick';

        element.bind(eventTrigger, function (jsEvent) {
          if (event.title != null) {
            if (self.currentProductModel == productModels.Maintenance) {
              self.taskservice.getTask(event.TaskRef, event.Company_Reference).subscribe(task => {
                self.activityService.getActivities(task.Task_GUID).subscribe(activities => {
                  task.TaskActivities = activities;
                  self.openModalEmitter.emit(task);
                  $('.tooltipDropEvent').remove();
                });
              }
              );
            }
            if (self.currentProductModel == productModels.Premium) {
              self.setDragging(true);
              var originalEventObject = $(this).data('eventObject');

              // we need to copy it, so that multiple events don't have a reference to the same object
              var copiedEventObject = $.extend({}, originalEventObject);

              var tooltip = '<div class="tooltipDropEvent panel panel-default" align="center" ' +
                'style="width:260px;height:180px;position:absolute;' +
                'z-index:10001;border-radius: 6px;box-shadow: 1px 1px 5px"' +
                '><div class="panel-heading"><strong>' + event.title + '</strong>' +
                '<button type="button" class="close cancelAction" data-dismiss="modal">&times;</button></div>' +
                '<div class="panel-body">' +
                '<b>Valgmuligheder</b>' +
                '<br>' +
                '<br>' +
                '<button id="GoToPlanningEvent" class="btn btn-default">Planlægning</button>' +
                '<button id="ShowDetailsEvent" class="btn btn-default" style="margin-left: 20px;">Detaljer</button>' +
                '</div>' +
                '</div>';
              $('body').append(tooltip);
              $(this).css('z-index', 10000);
              $('.tooltipDropEvent').fadeIn('500');
              $('.tooltipDropEvent').fadeTo('10', 1.9);
              $('.tooltipDropEvent').css('top', jsEvent.pageY + -175);
              $('.tooltipDropEvent').css('left', jsEvent.pageX + -120);


              $('#GoToPlanningEvent').click(function () {
                self.setDragging(true);
                self.redirectToScheduler(event.TaskRef);

                // set the date to Danish timezone
                $('.tooltipDropEvent').remove();
              });
              $('#ShowDetailsEvent').click(function () {
                self.setDragging(false);


                self.taskservice.getTask(event.TaskRef, event.Company_Reference).subscribe(x => self.openModalEmitter.emit(x));
                $('.tooltipDropEvent').remove();
              });

              $('.cancelAction').click(function () {
                self.setDragging(false);
                $('.tooltipDropEvent').remove();
              })
            }
          }
        });


        if (event.Icon) {
          // IF NOT Maintenance statement >>
          if (self.currentProductModel == productModels.Premium) {
            element.find('.fc-content').prepend('<i style=\'text-shadow: 0px 0px 3px #FFFFFF; margin-left: 3px;\' class=\'fa fa-' + event.Icon + '\'></i>');
          }
          // IF Maintenance statement >>
          else if (self.currentProductModel == productModels.Maintenance) {
            element.find('.fc-content').prepend('<i style=\'text-shadow: 0px 0px 3px #FFFFFF; margin-left: 3px; color: ' + event.IconColor + '\' class=\'fa fa-' + event.Icon + '\'></i>');
          }
        }
      },

      eventAfterAllRender(view) {

      },

      viewRender(view, element) {

        self.addTriggers();

        if (self.scrollerHeight > 0) {
          self.applyeScrollerDimensions();
        }
        // Automatically sets the minimum height of the view content to the current height, so the view doesnt jump when data is refreshed and rendered.
        const viewportHeight = $(window).height();
        $('.calenderDiv').css('min-height', viewportHeight - 150);


        if (view.type == 'dateRangeTimeLine' && self.currentView != view.type && self.stateChange) {
          self.stateChange = false;
          self.currentView = 'dateRangeTimeLine';

          self.DatePickerModel.StartDate = new Date(self.DatePickerModel.dummyStart.date.year, self.DatePickerModel.dummyStart.date.month - 1, self.DatePickerModel.dummyStart.date.day);
          $('#calendar').fullCalendar('gotoDate', self.DatePickerModel.StartDate);
          self.dateChangedEmitter.emit(true);
          self.rerenderCalendar(self._gantChart);
        }
        if (view.type != 'dateRangeTimeLine') {
          self.stateChange = true;
        }

        if (view.type == 'month') {
          // Start and end date is both wrong compared to the choosen month. The chosen month is in between start and end, for some reason....
          let difference = view.end - view.start;
          let newStart = (view.start + (difference / 2));

          // NM 040320 - Save change month >>
          self.DatePickerModel.StartDate = newStart;
          // NM 040320 - Save change month <<


          $('#calendar').fullCalendar('changeView', 'allDayWeekTimeline');
          $('#calendar').fullCalendar('gotoDate', newStart);
        } else if (view.type == 'basicDay') {
          // There is no timeline day in our version.. Therefor just reload current view, instead of basicDay default view.

          if (self.currentView == 'dateRangeTimeLine') {
            // Fix bug where DatoInterval calendar changes date when day clicked.
            $('#calendar').fullCalendar('gotoDate', self.DatePickerModel.StartDate);
          }
          $('#calendar').fullCalendar('changeView', self.currentView);
        } else if (view.type == 'timelineWeek') {
          self.DatePickerModel.StartDate = view.start;
        }

        // save currentView for refresh
        if ($('#calendar').fullCalendar('getView').type != undefined) {
          self.currentView = $('#calendar').fullCalendar('getView').type;
        }

      },


      resourceRender: function (resourceObj, labelTds, bodyTds) {


        var resourceLabel = labelTds.find('.fc-cell-text');

        resourceLabel.append('<span style=\'color: black; float: right;\'>' + (resourceObj.Responsible != '' ? ' ' + resourceObj.Responsible : '') + '</span>');

        // NM 240420 >>
        // THIS IS JQUERY!!
        if (self._showDatesOnResource) {

          //resourceLabel.css("white-space", 'pre');
          let datestring = self.convertservice.DatesToString(resourceObj.start, resourceObj.end);

          resourceLabel.append('<span style=\'color: black; float: right;\'>' + (datestring != '' ? ' ' + datestring : '') + '</span>');
        }
        // NM 240420 <<


        resourceLabel.hover(function () {

          let tooltip = self.getTaskTooltip(resourceObj);

          $('body').append(tooltip);


          $(this).mouseover(function (e) {
            $(this).css('z-index', 10000);
            $('.tooltipevent').fadeIn('500');
            $('.tooltipevent').fadeTo('10', 1.9);
          }).mousemove(function (e) {
            if (!self.isDragging) {
              $('.tooltipevent').css('top', e.pageY + -parseInt($('.tooltipevent').css('height'), 10) + -15);
              $('.tooltipevent').css('left', e.pageX + -100);
            } else {
              $('.tooltipevent').remove();
            }
          });
        });

        resourceLabel.mouseleave(function () {
          $(this).css('z-index', 8);
          $('.tooltipevent').remove()
        });
      },


      eventMouseover: function (calEvent, jsEvent) {
        if (self.isDragging == false) {

          let tooltip = self.getTaskTooltip(calEvent);

          $('body').append(tooltip);

          $(this).mouseover(function (e) {
            $(this).css('z-index', 10000);
            $('.tooltipevent').fadeIn('500');
            $('.tooltipevent').fadeTo('10', 1.9);
          }).mousemove(function (e) {
            if (!self.isDragging) {
              $('.tooltipevent').css('top', e.pageY + -parseInt($('.tooltipevent').css('height'), 10) + -15);
              $('.tooltipevent').css('left', e.pageX + -125);
            } else {
              $('.tooltipevent').remove();
            }
          });
        }
      },

      eventMouseout: function (calEvent, jsEvent) {
        $(this).css('z-index', 8);
        $('.tooltipevent').remove();
      },
    });

    var getFirstEvent = function () {
      return Math.min.apply(Math, this._gantChart.PlacedTasks.map(function (item) {
        return item.start;
      }));
    }

    // Checks if the dragged event is over the external event list.
    var isEventOverDiv = function (x, y) {

      var external_events = $('#external-events');
      var offset = external_events.offset();
      if (offset != null) {
        offset.right = external_events.width() + offset.left;
        offset.bottom = external_events.height() + offset.top;

        // Compare
        if (x >= offset.left
          && y >= offset.top
          && x <= offset.right
          && y <= offset.bottom) {
          return true;
        }
        return false;
      }
      return false;
    };

    var placeEventInCalendar = function (copiedEventObject, timeplanNo) {
      copiedEventObject.TimePlanRef = timeplanNo;
      copiedEventObject.ResourceRef = copiedEventObject.resourceId;
      copiedEventObject.OrigResourceRef = copiedEventObject.resourceId;
      // render the event on the calendar
      // the last `true` argument determines if the event "sticks" (http://arshaw.com/fullcalendar/docs/event_rendering/renderEvent/)
      $('#calendar').fullCalendar('renderEvent', copiedEventObject, true);

      // is the "remove after drop" checkbox checked?
      if ($('#drop-remove').is(':checked')) {
        // if so, remove the element from the "Draggable Events" list
        $(this).remove();
      }
    };

    // This function is called on every external event in the list.
    $('#external-events .fc-event').each(function () {

      // create an Event Object (http://arshaw.com/fullcalendar/docs/event_data/Event_Object/)
      // it doesn't need to have a start or end

      var eventObject = {
        title: $.trim($(this).text()), // use the element's text as the event title
        TaskRef: $(this).children('.taskRef').val(),
        stick: false
      };

      // store the Event Object in the DOM element so we can get to it later
      $(this).data('eventObject', eventObject);

      // make the event draggable using jQuery UI
      $(this).draggable({
        zIndex: 999,
        revert: true,      // will cause the event to go back to its
        revertDuration: 0  //  original position after the drag
      });
    });
    if (this.validateStyle && this.isInitialized) {
      this.validateStyles(this.screenHeight - 380)
    }
    this.isInitialized = true


    this.isInitializedEmitter.emit(this.isInitialized);
  }

  private updateEventFromEventDrop(event) {
    event.eventStartEditable = false;
    this.updateTaskTime({ Task_GUID: event.TaskRef, start: event.start, end: event.end, Company_Reference: event.Company_Reference });
    event.OrigResourceRef = event.resourceId;
  }

  setDragging(value: boolean) {
    this.isDragging = value;
  }

  getTasks(taskPageModel: TaskPageModel) {
    this.refreshCurrentTaskListEmitter.emit(taskPageModel);
  }

  OpenCreateNotificationModal() {
    $('#createNotificationModal').modal('show');
  }

  createNotification(notification) {
    this.notificationService.Post(notification).subscribe(x => {
      this.refreshCalendarEmitter.emit(new FilterModel(moment(this.DatePickerModel.StartDate).format(environment.FULL_DATETIME_FORMAT), moment(this.DatePickerModel.EndDate).format(environment.FULL_DATETIME_FORMAT)));
      $('#createNotificationModal').modal('hide');
    });
  }

  // OLD >>
  changeChosenResponsible(ref: string) {
    this.changeChosenResponsibleEmitter.emit(ref);
  }

  changeChosenCategory(ref: string) {
    this.changeChosenCategoryEmitter.emit(ref);
  }

  changeChosenStatus(ref: string) {
    this.changeChosenStatusEmitter.emit(ref);
  }

  // NEW >>

  setSelectedFilter(field_name: string, field_value: string): boolean {
    let filterFields = this.externalFilter.FilterFields.filter(field => field.Field_Name.toUpperCase() == field_name.toUpperCase());
    let isChecked: boolean = false;
    for (let field of filterFields) {
      if (field_value.toUpperCase() == field.Field_Value.toUpperCase()) {
        isChecked = true;
      }
    }
    return isChecked;
  }

  fieldIsSelected(field_name: string, field_value: string) {
    let externalFilterField: ExternalFilterField = {
      SalesPerson_Code: this.externalFilter.SalesPersonCode,
      View_Name: this.externalFilter.ViewName,
      Field_Name: field_name,
      Field_Value: field_value
    };
    this.validateFilterFieldEmitter.emit(externalFilterField);
  }

  closeSelector(id: string) {
    let checkboxes = document.getElementById(id);
    checkboxes.style.display = 'none';
  }

  showSpecificCheckBoxes(id: string) {
    let checkboxes = document.getElementById(id);
    checkboxes.style.display = 'block';
  }
}





// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/charts/gant-chart/gant-chart-view.component.ts